// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uu22h","title":"Header_title__4HPgL","side":"Header_side__23CEl"};